import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { ServicoBio, BioLink } from '../services/servico-bio.service';
import { AutorizacaoService } from '../../services/autorizacao.service';
import { NotificationService } from '@progress/kendo-angular-notification';

@Component({
  selector: 'app-bio-links',
  templateUrl: './bio-links.component.html',
  styleUrls: ['./bio-links.component.scss']
})
export class BioLinksComponent implements OnInit {

  links: BioLink[] = [];
  carregando = true;
  salvando = false;
  idBioPagina: number;
  slugBioPagina: string;
  corPrimaria: string = '#2e7d32';
  modoPreview: 'mobile' | 'desktop' = 'mobile';
  urlPreview: SafeResourceUrl;
  timestampPreview = Date.now();
  modalDeletar = false;
  linkApagar: BioLink = null;

  exibirDialogNovoItem = false;
  exibirDialogPlataformas = false;
  plataformasSelecionadas = new Set<string>();
  linkExpandido: number | string = null;
  erroValidacaoItem: string = null;
  private _tempIdCounter = 0;

  tiposDeLink: { valor: string; label: string; icone: string; cor: string; logo?: string }[] = [
    { valor: 'cardapio', label: 'Meu Cardápio', icone: '', cor: '#E53935', logo: 'assets/fidelidade/promokit-preto.png' },
    { valor: 'whatsapp', label: 'WhatsApp', icone: 'fab fa-whatsapp', cor: '#25D366', logo: 'assets/icons/whatsapp_logo_oficial.png' },
    { valor: 'instagram', label: 'Instagram', icone: 'fab fa-instagram', cor: '#E1306C', logo: 'assets/fidelidade/icones/instagram.svg' },
    { valor: 'ifood', label: 'iFood', icone: '', cor: '#EA1D2C', logo: 'assets/icons/logo-ifood.png' },
    { valor: 'telefone', label: 'Telefone', icone: 'fas fa-phone', cor: '#1976D2' },
    { valor: 'localizacao', label: 'Localização', icone: 'fas fa-map-marker-alt', cor: '#F57C00' },
    { valor: 'reserva', label: 'Reserva', icone: 'fas fa-calendar-check', cor: '#7B1FA2' },
    { valor: '99food', label: '99Food', icone: '', cor: '#FFCC00', logo: 'assets/icons/logo-99food.png' },
    { valor: 'aiqfome', label: 'Aiqfome', icone: '', cor: '#7D0DC3', logo: 'assets/icons/logo-aiqfome.png' },
    { valor: 'site', label: 'Site / Outro', icone: 'fas fa-globe', cor: '#455A64' }
  ];

  iconesAppsPredefinidos: { valor: string; label: string; imagem?: string }[] = [
    { valor: 'assets/fidelidade/promokit-preto.png', label: 'Meu Cardápio', imagem: 'assets/fidelidade/promokit-preto.png' },
    { valor: 'assets/icons/whatsapp_logo_oficial.png', label: 'WhatsApp', imagem: 'assets/icons/whatsapp_logo_oficial.png' },
    { valor: 'assets/fidelidade/icones/instagram.svg', label: 'Instagram', imagem: 'assets/fidelidade/icones/instagram.svg' },
    { valor: 'assets/icons/logo-ifood.png', label: 'iFood', imagem: 'assets/icons/logo-ifood.png' },
    { valor: 'assets/icons/logo-99food.png', label: '99Food', imagem: 'assets/icons/logo-99food.png' },
    { valor: 'assets/icons/logo-aiqfome.png', label: 'Aiqfome', imagem: 'assets/icons/logo-aiqfome.png' }
  ];

  iconesPredefinidos: { valor: string; label: string; imagem?: string }[] = [
    { valor: 'fas fa-link', label: 'Link' },
    { valor: 'fas fa-store', label: 'Loja' },
    { valor: 'fas fa-utensils', label: 'Cardápio' },
    { valor: 'fas fa-hamburger', label: 'Lanche' },
    { valor: 'fas fa-motorcycle', label: 'Entrega' },
    { valor: 'fas fa-phone', label: 'Telefone' },
    { valor: 'fas fa-map-marker-alt', label: 'Mapa' },
    { valor: 'fas fa-calendar-check', label: 'Reserva' },
    { valor: 'fas fa-shopping-bag', label: 'Pedido' },
    { valor: 'fas fa-ticket-alt', label: 'Cupom' },
    { valor: 'fas fa-star', label: 'Destaque' },
    { valor: 'fas fa-globe', label: 'Site' }
  ];

  constructor(
    private servicoBio: ServicoBio,
    private autorizacaoService: AutorizacaoService,
    private notificationService: NotificationService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.autorizacaoService.fetchUser().subscribe(usuario => {
      if (!usuario?.empresa?.id) {
        this.carregando = false;
        this.mostrarNotificacao('Não foi possível carregar os dados da empresa.', 'error');
        return;
      }

      this.servicoBio.obterBioPagina(usuario.empresa.id).then((data: any) => {
        if (data && data.id) {
          this.idBioPagina = data.id;
          this.slugBioPagina = data.slug;
          this.corPrimaria = data.corPrimaria || '#2e7d32';
          this.atualizarUrlPreview();
          this.carregarLinks();
        } else {
          this.carregando = false;
        }
      }).catch(() => {
        this.carregando = false;
      });
    });
  }

  carregarLinks() {
    this.carregando = true;
    this.servicoBio.obterLinks(this.idBioPagina).then((data: BioLink[]) => {
      this.links = data || [];
      this.carregando = false;
    }).catch(() => {
      this.carregando = false;
    });
  }

  novoItem() {
    this.plataformasSelecionadas.clear();
    this.exibirDialogNovoItem = true;
  }

  selecionarTipoDeItem(tipo: 'link' | 'separator') {
    this.exibirDialogNovoItem = false;

    if (tipo === 'link') {
      this.exibirDialogPlataformas = true;
      return;
    }

    this.criarSeparador();
  }

  criarSeparador() {
    const tempId = '_new_' + (++this._tempIdCounter);
    const separador: BioLink = {
      id: null,
      _tempId: tempId,
      idBioPagina: this.idBioPagina,
      itemType: 'separator',
      modoVisual: 'icon',
      tipo: 'site',
      titulo: '',
      subtitulo: '',
      icone: '',
      urlIconeCustomizado: '',
      urlImagem: '',
      url: '',
      etiqueta: '',
      cor: null,
      corSubtitulo: null,
      separatorText: '',
      separatorShowLine: true,
      ordem: this.links.length,
      ativo: true
    };

    this.links.push(separador);
    this.linkExpandido = tempId;
  }

  togglePlataforma(tipo: string) {
    if (this.plataformasSelecionadas.has(tipo)) {
      this.plataformasSelecionadas.delete(tipo);
    } else {
      this.plataformasSelecionadas.add(tipo);
    }
  }

  confirmarPlataformas() {
    let primeiroTempId: string = null;

    this.plataformasSelecionadas.forEach(tipo => {
      const tipoInfo = this.tiposDeLink.find(t => t.valor === tipo);
      const tempId = '_new_' + (++this._tempIdCounter);
      const novoLink: BioLink = {
        id: null,
        _tempId: tempId,
        idBioPagina: this.idBioPagina,
        itemType: 'link',
        modoVisual: 'icon',
        tipo,
        titulo: tipoInfo ? tipoInfo.label : tipo,
        subtitulo: '',
        icone: '',
        urlIconeCustomizado: '',
        urlImagem: '',
        url: '',
        etiqueta: '',
        cor: tipoInfo ? tipoInfo.cor : '#455A64',
        corSubtitulo: null,
        separatorText: '',
        separatorShowLine: true,
        ordem: this.links.length,
        ativo: true
      };

      if (tipo === 'whatsapp') {
        novoLink.url = 'https://wa.me/55';
      } else if (tipo === 'telefone') {
        novoLink.url = 'tel:+55';
      } else if (tipo === '99food') {
        novoLink.url = 'https://www.99food.com/';
      } else if (tipo === 'aiqfome') {
        novoLink.url = 'https://aiqfome.com/';
      }

      if (!primeiroTempId) primeiroTempId = tempId;
      this.links.push(novoLink);
    });

    this.exibirDialogPlataformas = false;
    if (primeiroTempId) {
      this.linkExpandido = primeiroTempId;
    }
  }

  editarLink(link: BioLink, index: number) {
    this.erroValidacaoItem = null;
    this.linkExpandido = this.obtenhaChave(link, index);
  }

  isGibberish(text: string): boolean {
    const limpo = (text || '').replace(/\s/g, '');
    const repetido = /^(.)\1{3,}$/i;
    const prefixos = /^(abc|123|test|xxx|qwer|asdf|zxcv)/i;
    const somenteConsoantes = /^[bcdfghjklmnpqrstvwxyz]{4,}$/i;
    return repetido.test(limpo) || prefixos.test(limpo) || somenteConsoantes.test(limpo);
  }

  salvarLinkInline(link: BioLink, index: number) {
    this.erroValidacaoItem = this.validarItem(link);
    if (this.erroValidacaoItem) {
      return;
    }

    this.salvando = true;
    const operacao = link.id
      ? this.servicoBio.atualizarLink(link.id, link)
      : this.servicoBio.salvarLink(link);

    operacao.then((resultado: any) => {
      this.salvando = false;
      if (!link.id && resultado && resultado.id) {
        this.links[index] = { ...link, id: resultado.id, _tempId: undefined };
      }
      this.linkExpandido = null;
      this.recarregarPreview();
      this.mostrarNotificacao('Item salvo com sucesso!', 'success');
    }).catch(() => {
      this.salvando = false;
      this.mostrarNotificacao('Erro ao salvar item. Tente novamente.', 'error');
    });
  }

  cancelarEdicaoInline(link: BioLink, index: number) {
    this.erroValidacaoItem = null;
    if (!link.id) {
      this.links.splice(index, 1);
    }
    this.linkExpandido = null;
  }

  confirmarExclusao(link: BioLink) {
    this.linkApagar = link;
    this.modalDeletar = true;
  }

  fecharModalDeletar(confirmou: string) {
    if (confirmou === 'sim') {
      if (this.linkApagar.id) {
        this.servicoBio.excluirLink(this.linkApagar.id).then(() => {
          this.links = this.links.filter(l => l !== this.linkApagar);
          this.recarregarPreview();
          this.mostrarNotificacao('Item removido.', 'success');
          this.linkApagar = null;
          this.modalDeletar = false;
        });
        return;
      }

      this.links = this.links.filter(l => l !== this.linkApagar);
      this.recarregarPreview();
      this.mostrarNotificacao('Item removido.', 'success');
    }

    this.linkApagar = null;
    this.modalDeletar = false;
  }

  onDrop(event: CdkDragDrop<BioLink[]>) {
    const ordemAnterior = [...this.links];
    moveItemInArray(this.links, event.previousIndex, event.currentIndex);
    this.links.forEach((link, index) => link.ordem = index);
    const ids = this.links.map(l => l.id).filter(id => id != null);
    this.servicoBio.reordenarLinks(this.idBioPagina, ids)
      .then(() => this.recarregarPreview())
      .catch(() => {
        this.links = ordemAnterior;
        this.links.forEach((link, index) => link.ordem = index);
        this.carregarLinks();
      });
  }

  toggleAtivoLink(link: BioLink, ativo: boolean) {
    link.ativo = ativo;
    if (link.id) {
      this.servicoBio.atualizarLink(link.id, link).then(() => {
        this.recarregarPreview();
      }).catch(() => {
        link.ativo = !ativo;
      });
      return;
    }

    this.recarregarPreview();
  }

  isSeparador(link: BioLink | null): boolean {
    return ((link?.itemType) || 'link') === 'separator';
  }

  obtenhaChave(link: BioLink, index: number): number | string {
    return link.id || link._tempId || index;
  }

  obtenhaTituloCompacto(link: BioLink | null): string {
    if (!link) {
      return 'Item';
    }

    if (this.isSeparador(link)) {
      return (link.separatorText || '').trim() || 'Separador';
    }
    return link.titulo || 'Link sem título';
  }

  obtenhaResumoSeparador(link: BioLink | null): string {
    if (!link) {
      return '';
    }

    const temTexto = Boolean((link.separatorText || '').trim());
    const temLinha = link.separatorShowLine !== false;

    if (temTexto && temLinha) return 'Texto + linha';
    if (temTexto) return 'Apenas texto';
    if (temLinha) return 'Linha horizontal';
    return 'Separador incompleto';
  }

  obtenhaIconeDoTipo(tipo: string, itemType: 'link' | 'separator' = 'link'): string {
    if (itemType === 'separator') {
      return 'fas fa-grip-lines';
    }

    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found ? found.icone : 'fas fa-link';
  }

  obtenhaIconeDoLink(link: Pick<BioLink, 'tipo' | 'itemType' | 'icone'> | null): string {
    if (!link) {
      return 'fas fa-link';
    }

    const iconeSelecionado = this.obtenhaIconeSelecionado(link);
    if (iconeSelecionado && !this.ehIconeImagem(iconeSelecionado)) {
      return iconeSelecionado;
    }

    return this.obtenhaIconeDoTipo(link.tipo, link.itemType || 'link');
  }

  obtenhaIconeSelecionado(link: Pick<BioLink, 'tipo' | 'itemType' | 'icone'> | null): string {
    if (!link || (link.itemType || 'link') === 'separator') {
      return '';
    }

    const icone = String(link.icone || '').trim();
    const iconeAutomatico = this.obtenhaIconeDoTipo(link.tipo, link.itemType || 'link');

    if (!icone || icone === iconeAutomatico) {
      return '';
    }

    return icone;
  }

  usaIconeAutomatico(link: BioLink | null): boolean {
    return !this.obtenhaIconeSelecionado(link);
  }

  obtenhaModoVisual(link: BioLink | null): 'icon' | 'image' {
    if (!link || this.isSeparador(link)) {
      return 'icon';
    }

    if (this.temImagemDoLink(link)) {
      return 'image';
    }

    return link.modoVisual === 'image' ? 'image' : 'icon';
  }

  usarImagemNoLink(link: BioLink | null): boolean {
    return this.obtenhaModoVisual(link) === 'image';
  }

  usarIconeNoLink(link: BioLink | null): boolean {
    return this.obtenhaModoVisual(link) === 'icon';
  }

  selecionarModoVisual(link: BioLink, modo: 'icon' | 'image'): void {
    link.modoVisual = modo;

    if (modo === 'icon') {
      link.urlImagem = '';
      link.urlIconeCustomizado = '';
    }
  }

  ehIconeImagem(icone: string | null | undefined): boolean {
    const valor = String(icone || '').trim();
    if (!valor) {
      return false;
    }

    return /^assets\//i.test(valor) || /\.(svg|png|jpe?g|webp|gif)$/i.test(valor);
  }

  obtenhaImagemDoIcone(link: Pick<BioLink, 'tipo' | 'itemType' | 'icone'> | null): string {
    if (!link || (link.itemType || 'link') === 'separator') {
      return '';
    }

    const iconeSelecionado = this.obtenhaIconeSelecionado(link);
    if (this.ehIconeImagem(iconeSelecionado)) {
      return iconeSelecionado;
    }

    if (!iconeSelecionado) {
      return this.obtenhaLogoDoTipo(link.tipo, link.itemType || 'link') || '';
    }

    return '';
  }

  selecionarIcone(link: BioLink, icone: string): void {
    link.modoVisual = 'icon';
    link.urlImagem = '';
    link.urlIconeCustomizado = '';
    link.icone = icone || '';
  }

  exibeLogoDoLink(link: BioLink | null): boolean {
    if (!link || this.isSeparador(link) || this.temImagemDoLink(link)) {
      return false;
    }

    return Boolean(this.obtenhaImagemDoIcone(link));
  }

  obtenhaCorDecorativaDoLink(link: Pick<BioLink, 'tipo' | 'itemType' | 'icone'> | null): string {
    if (!link || this.isSeparador(link as BioLink)) {
      return this.obtenhaCorDoTipo('site');
    }

    const icone = this.obtenhaIconeSelecionado(link);
    if (icone && !this.ehIconeImagem(icone)) {
      return this.obtenhaTemaDoIcone(icone).cor;
    }

    return this.obtenhaCorDoTipo(link.tipo, link.itemType || 'link');
  }

  obtenhaFundoDecorativoDoLink(link: Pick<BioLink, 'tipo' | 'itemType' | 'icone'> | null): string {
    if (!link || this.isSeparador(link as BioLink)) {
      return this.obtenhaTemaDoIcone('').fundo;
    }

    const icone = this.obtenhaIconeSelecionado(link);
    if (icone && !this.ehIconeImagem(icone)) {
      return this.obtenhaTemaDoIcone(icone).fundo;
    }

    const cor = this.obtenhaCorDoTipo(link.tipo, link.itemType || 'link');
    return cor ? `${cor}18` : this.obtenhaTemaDoIcone('').fundo;
  }

  obtenhaBordaDecorativaDoLink(link: Pick<BioLink, 'tipo' | 'itemType' | 'icone'> | null): string {
    if (!link || this.isSeparador(link as BioLink)) {
      return this.obtenhaTemaDoIcone('').borda;
    }

    const icone = this.obtenhaIconeSelecionado(link);
    if (icone && !this.ehIconeImagem(icone)) {
      return this.obtenhaTemaDoIcone(icone).borda;
    }

    const cor = this.obtenhaCorDoTipo(link.tipo, link.itemType || 'link');
    return cor ? `${cor}30` : this.obtenhaTemaDoIcone('').borda;
  }

  obtenhaCorDecorativaDoIcone(icone: string): string {
    return this.obtenhaTemaDoIcone(icone).cor;
  }

  obtenhaFundoDecorativoDoIcone(icone: string): string {
    return this.obtenhaTemaDoIcone(icone).fundo;
  }

  obtenhaBordaDecorativaDoIcone(icone: string): string {
    return this.obtenhaTemaDoIcone(icone).borda;
  }

  obtenhaCorDoTipo(tipo: string, itemType: 'link' | 'separator' = 'link'): string {
    if (itemType === 'separator') {
      return '#6c757d';
    }

    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found ? found.cor : '#455A64';
  }

  obtenhaCorDoLink(link: Pick<BioLink, 'tipo' | 'itemType' | 'cor'> | null): string {
    if (!link) {
      return '#455A64';
    }

    return link.cor || this.obtenhaCorDoTipo(link.tipo, link.itemType || 'link');
  }

  obtenhaCorDoSubtituloDoLink(link: Pick<BioLink, 'corSubtitulo'> | null): string {
    return link?.corSubtitulo || null;
  }

  private obtenhaTemaDoIcone(icone: string | null | undefined): { cor: string; fundo: string; borda: string } {
    const valor = String(icone || '').trim();
    const temas: { [key: string]: { cor: string; fundo: string; borda: string } } = {
      'fas fa-link': { cor: '#4E72B8', fundo: '#EEF3FB', borda: '#D5E1F2' },
      'fas fa-store': { cor: '#6A63D9', fundo: '#F1EFFE', borda: '#DDD8FA' },
      'fas fa-utensils': { cor: '#D97745', fundo: '#FCEFE7', borda: '#F4D8CA' },
      'fas fa-hamburger': { cor: '#D38A2C', fundo: '#FDF1DF', borda: '#F2D8AE' },
      'fas fa-motorcycle': { cor: '#2F8F83', fundo: '#E8F6F3', borda: '#C7E8E1' },
      'fas fa-phone': { cor: '#2F7DE1', fundo: '#EAF2FE', borda: '#D0E0FB' },
      'fas fa-map-marker-alt': { cor: '#2E9E74', fundo: '#EAF8F1', borda: '#CDEBD9' },
      'fas fa-calendar-check': { cor: '#8A63D2', fundo: '#F3EEFC', borda: '#DED1F6' },
      'fas fa-shopping-bag': { cor: '#C45B74', fundo: '#FCECF1', borda: '#F2D2DB' },
      'fas fa-ticket-alt': { cor: '#E28A2E', fundo: '#FEF2E5', borda: '#F6D7B2' },
      'fas fa-star': { cor: '#C89B2D', fundo: '#FCF4E3', borda: '#F1DEB0' },
      'fas fa-globe': { cor: '#4A7A96', fundo: '#ECF4F8', borda: '#D3E3EB' }
    };

    return temas[valor] || { cor: '#5D7088', fundo: '#F2F5F8', borda: '#DCE4EB' };
  }

  obtenhaLabelDoTipo(tipo: string, itemType: 'link' | 'separator' = 'link'): string {
    if (itemType === 'separator') {
      return 'Separador';
    }

    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found ? found.label : tipo;
  }

  obtenhaLogoDoTipo(tipo: string, itemType: 'link' | 'separator' = 'link'): string {
    if (itemType === 'separator') {
      return null;
    }

    const found = this.tiposDeLink.find(t => t.valor === tipo);
    return found && found.logo ? found.logo : null;
  }

  temImagemDoLink(link: BioLink | null): boolean {
    return Boolean(this.obtenhaUrlImagemDoLink(link));
  }

  obtenhaUrlImagemDoLink(link: BioLink | null): string {
    if (!link || this.isSeparador(link)) {
      return '';
    }

    const url = String(link.urlImagem || link.urlIconeCustomizado || '').trim();
    if (!url) {
      return '';
    }

    if (/^(https?:)?\/\//i.test(url) || /^(data|blob):/i.test(url) || url.startsWith('/') || url.startsWith('assets/') || url.startsWith('./') || url.startsWith('../')) {
      return url;
    }

    return '/images/empresa/' + url;
  }

  placeholderUrl(tipo: string): string {
    if (tipo === 'whatsapp') return 'https://wa.me/5511999999999';
    if (tipo === 'telefone') return 'tel:+5511999999999';
    if (tipo === '99food') return 'https://www.99food.com/seu-restaurante';
    if (tipo === 'aiqfome') return 'https://aiqfome.com/seu-restaurante';
    return 'https://...';
  }

  atualizarUrlPreview() {
    if (!this.slugBioPagina) {
      this.urlPreview = null;
      return;
    }
    const url = window.location.origin + '/bio/' + this.slugBioPagina + '?preview=true&t=' + this.timestampPreview;
    this.urlPreview = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  recarregarPreview() {
    this.timestampPreview = Date.now();
    this.atualizarUrlPreview();
  }

  abrirEmNovaAba() {
    if (!this.slugBioPagina) return;
    window.open(window.location.origin + '/bio/' + this.slugBioPagina, '_blank');
  }

  private validarItem(link: BioLink): string | null {
    if (this.isSeparador(link)) {
      return this.validarSeparador(link);
    }
    return this.validarLink(link);
  }

  private validarSeparador(link: BioLink): string | null {
    const texto = (link.separatorText || '').trim();
    const exibeLinha = link.separatorShowLine !== false;

    if (!texto && !exibeLinha) {
      return 'Informe um texto ou ative a linha do separador.';
    }

    return null;
  }

  private validarLink(link: BioLink): string | null {
    link.icone = String(link.icone || '').trim();
    link.urlImagem = String(link.urlImagem || '').trim();
    link.url = String(link.url || '').trim();
    link.modoVisual = this.obtenhaModoVisual(link);

    if (link.modoVisual === 'icon') {
      link.urlImagem = '';
    }

    if (link.modoVisual === 'image' && !link.urlImagem) {
      return 'Envie uma imagem para usar thumb ou selecione o modo ícone.';
    }

    link.urlIconeCustomizado = link.urlImagem;

    if (!link.titulo) {
      return 'Informe o título do link.';
    }
    if (this.isGibberish(link.titulo)) {
      return 'O título do link parece inválido.';
    }
    if (link.subtitulo && link.subtitulo.trim() && this.isGibberish(link.subtitulo)) {
      return 'O subtítulo do link parece inválido.';
    }
    if (link.etiqueta && link.etiqueta.trim() && this.isGibberish(link.etiqueta)) {
      return 'A etiqueta do link parece inválida.';
    }
    if (!link.url) {
      return 'Informe a URL do link.';
    }
    if (!this.ehUrlSeguraParaTipo(link.url, link.tipo)) {
      return 'URL inválida ou insegura. Use um endereço válido (https, tel, WhatsApp ou Instagram).';
    }

    return null;
  }

  private ehUrlSeguraParaTipo(url: string, tipo: string): boolean {
    const valor = String(url || '').trim();
    if (!valor) return false;
    if (this.temProtocoloBloqueado(valor)) return false;

    switch (tipo) {
      case 'telefone':
        return this.validarTelefone(valor);
      case 'whatsapp':
        return this.validarWhatsapp(valor);
      case 'instagram':
        return this.validarInstagram(valor);
      case 'localizacao':
        return true; // endereço livre, o backend converte para Google Maps quando necessário
      default:
        return this.validarHttpOuHttps(valor);
    }
  }

  private temProtocoloBloqueado(url: string): boolean {
    return /^(javascript|data|vbscript|file|blob):/i.test(String(url || '').trim());
  }

  private validarTelefone(url: string): boolean {
    const valor = String(url || '').trim();
    const numero = valor.replace(/^tel:/i, '').replace(/[^\d+]/g, '');
    const apenasDigitos = numero.replace(/\D/g, '');
    return apenasDigitos.length >= 8;
  }

  private validarWhatsapp(url: string): boolean {
    const valor = String(url || '').trim();
    const digitosDiretos = valor.replace(/\D/g, '');
    if (digitosDiretos.length >= 10) return true;

    if (!this.validarHttpOuHttps(valor)) return false;

    try {
      const candidato = /^[a-z][a-z0-9+.-]*:/i.test(valor) ? valor : `https://${valor}`;
      const parsed = new URL(candidato);
      const host = parsed.hostname.replace(/^www\./, '').toLowerCase();
      return host === 'wa.me' || host === 'api.whatsapp.com' || host === 'web.whatsapp.com';
    } catch {
      return false;
    }
  }

  private validarInstagram(url: string): boolean {
    const valor = String(url || '').trim();
    if (/^@?[a-zA-Z0-9._]{1,30}$/.test(valor)) return true;

    if (!this.validarHttpOuHttps(valor)) return false;

    try {
      const candidato = /^[a-z][a-z0-9+.-]*:/i.test(valor) ? valor : `https://${valor}`;
      const parsed = new URL(candidato);
      const host = parsed.hostname.replace(/^www\./, '').toLowerCase();
      if (host !== 'instagram.com' && host !== 'l.instagram.com') return false;

      const handle = parsed.pathname.split('/').filter(Boolean)[0] || '';
      return /^[a-zA-Z0-9._]{1,30}$/.test(handle);
    } catch {
      return false;
    }
  }

  private validarHttpOuHttps(url: string): boolean {
    const valor = String(url || '').trim();
    if (!valor) return false;
    if (valor.startsWith('/')) return true;

    try {
      const candidato = /^[a-z][a-z0-9+.-]*:/i.test(valor) ? valor : `https://${valor}`;
      const parsed = new URL(candidato);
      return parsed.protocol === 'http:' || parsed.protocol === 'https:';
    } catch {
      return false;
    }
  }

  private mostrarNotificacao(mensagem: string, tipo: 'success' | 'error') {
    this.notificationService.show({
      content: mensagem,
      type: { style: tipo, icon: true },
      position: { horizontal: 'right', vertical: 'top' },
      hideAfter: 3000
    });
  }
}
